import React, { Component } from 'react';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import { resetPassword } from '../actions/actions';

import apiErrors from '../modules/apierrors';
import getErrors from '../modules/geterrors';

// Taken from https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;


class ForgotPassword extends Component {

  constructor() {
    super();

    this.state = {
      email: '',
      password: '',
      passwordConfirmation: '',
      successMessage: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.auth.passwordReset.isSuccess && nextProps.auth.passwordReset.isSuccess) {
      this.setState({ email: '', password: '', passwordConfirmation: '', successMessage: 'Your password was reset! ' });
    } else {
      this.setState({ successMessage: '' });
    }
  }

  handleForm = (event) => {
    event.preventDefault();

    const email = this.emailInput.getValue();
    const password = this.passwordInput.getValue();
    const passwordConfirmation = this.passwordConfirmationInput.getValue();

    this.setState({ email, password, passwordConfirmation });
  }

  handleClick(event) {
    event.preventDefault();
    const token = this.props.params.resetToken;
    const email = this.state.email.trim();
    const password = this.state.password.trim();
    const passwordConfirmation = this.state.passwordConfirmation.trim();

    const creds = { token, email, password, password_confirmation: passwordConfirmation };
    this.props.dispatch(resetPassword(creds));
  }

  render() {
    const token = this.props.params.resetToken;
    const validEmail = this.state.email.match(emailRegexp);

    const disabled = !validEmail
                    || this.state.password.length < 6
                    || this.state.passwordConfirmation < 6
                    || token.length === 0
                    || this.props.isWaiting.PASSWORD_RESET;

    const { errorMessages, validationErrors } = getErrors(this.props.auth.passwordReset.errors);
    const emailErrorMessage = apiErrors[validationErrors.email] || validationErrors.email;
    const passwordErrorMessage = apiErrors[validationErrors.password] || validationErrors.password;

    return (
      <div className="unregistered" key="passwordreset">
        <Card>
          <CardHeader title="Reset your password" />
          <CardText>
            <div className="pronounce-login">
              <form>
                <TextField
                  autoFocus
                  errorText={emailErrorMessage}
                  onChange={this.handleForm}
                  ref={(input) => { this.emailInput = input; }}
                  type="text"
                  name="email"
                  value={this.state.email}
                  floatingLabelText="Email"
                /><br />
                <TextField
                  errorText={passwordErrorMessage}
                  onChange={this.handleForm}
                  ref={(input) => { this.passwordInput = input; }}
                  type="password"
                  name="password"
                  value={this.state.password}
                  floatingLabelText="Password"
                  hintText="At least 6 characters"
                /><br />
                <TextField
                  onChange={this.handleForm}
                  ref={(input) => { this.passwordConfirmationInput = input; }}
                  type="password"
                  name="password_confirmation"
                  value={this.state.password_confirmation}
                  floatingLabelText="Password confirmation"
                  hintText="Match the password field"
                />
                <br />
                <FlatButton
                  disabled={disabled}
                  onClick={event => this.handleClick(event)}
                  type="submit"
                  label="Reset Password"
                />


              </form>
            </div>
          </CardText>
          <CardText>{errorMessages.map(error => <div><strong>{error}</strong></div>)}</CardText>
          <CardText>{this.state.successMessage}</CardText>

        </Card>
      </div>
    );
  }

}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/ResetPassword.js